const ClearUser =()=>{
    let user= localStorage.removeItem("LogedUser");

}
export default ClearUser;
